/* NC custom furniture page (naturescollection.us): effects for the nc-pol-* sections.
   Reveal on scroll, lazy muted video loops, hero parallax, mobile quote bar, gallery cursor,
   sheepskin scroll-spy, film with sound, and links that prefill the enquiry form (#enquiry).
   Self-contained: needs no theme JS. Prestige 10.7 note: theme.js scrolls same-page "#hash" links itself
   (only when the link has the same ?query as the page), so links with a ?query are handled here. */
(function () {
  'use strict';
  if (window.__ncPol) return;
  window.__ncPol = true;

  var ENQUIRY_ID = 'enquiry';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;

  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function once(el, k) { var d = el.__ncPol || (el.__ncPol = {}); if (d[k]) return false; d[k] = 1; return true; }
  function play(v) { if (!v) return; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  /* ---------- Enquiry form prefill ----------
     Links with [data-pol-enquire] carry ?furniture=..&wool=..&color=..#enquiry.
     When the enquiry section exposes its API (window.ncEnquiry, nc-pol-anfrage), that section handles these links and
     the page URL itself, and this file only steps in through ncPol.prefill(). Without the API (older or other form),
     the values are written straight into matching fields (radio/checkbox by value or data-key, select by option,
     text input by value); param names map to field names through ALIAS, so English and the original .eu names work. */
  var ALIAS = {
    furniture: ['furniture', 'piece', 'moebel'], moebel: ['moebel', 'furniture', 'piece'],
    wool: ['wool', 'sheepskin', 'fell'], fell: ['fell', 'wool', 'sheepskin'],
    color: ['color', 'colour', 'farbe'], farbe: ['farbe', 'color', 'colour']
  };
  function formApi() { var a = window.ncEnquiry; return a && typeof a.apply === 'function' ? a : null; }
  function first(o, keys) { for (var i = 0; i < keys.length; i++) if (o[keys[i]]) return o[keys[i]]; return ''; }

  function formRoot() {
    var a = document.getElementById(ENQUIRY_ID);
    return document.querySelector('.pol-anfrage') || (a && (a.closest('section') || a.nextElementSibling)) || null;
  }

  function fire(el) {
    ['input', 'change'].forEach(function (t) {
      var ev;
      try { ev = new Event(t, { bubbles: true }); } catch (e) { ev = document.createEvent('Event'); ev.initEvent(t, true, false); }
      el.dispatchEvent(ev);
    });
  }

  function fillField(root, name, value, onlyIfEmpty) {
    var els = $$('[name="' + name.replace(/"/g, '') + '"]', root);
    if (!els.length) return false;
    var v = norm(value), first = els[0];
    if (first.type === 'radio' || first.type === 'checkbox') {
      if (onlyIfEmpty && els.some(function (x) { return x.checked; })) return true;
      var hit = els.filter(function (x) { return norm(x.value) === v; })[0] ||
        els.filter(function (x) { return norm(x.getAttribute('data-key')) === v; })[0] ||
        els.filter(function (x) { return v && norm(x.value).indexOf(v) === 0; })[0];
      if (!hit) return false;
      if (first.type === 'radio' || !hit.checked) { hit.checked = true; fire(hit); }
      return true;
    }
    if (first.tagName === 'SELECT') {
      if (onlyIfEmpty && first.value) return true;
      var opt = [].filter.call(first.options, function (o) { return norm(o.value) === v || norm(o.text) === v; })[0];
      if (!opt) return false;
      first.value = opt.value; fire(first);
      return true;
    }
    if (first.type === 'file') return false;
    if (onlyIfEmpty && first.value) return true;
    first.value = value; fire(first);
    return true;
  }

  function prefill(params, onlyIfEmpty, retry) {
    if (!params) return;
    var api = formApi();
    if (api) {
      api.apply({ type: first(params, ['type', 'furniture', 'piece', 'moebel']), sheepskin: first(params, ['sheepskin', 'wool', 'fell']), color: first(params, ['color', 'colour', 'farbe']) });
      return;
    }
    var root = formRoot();
    if (!root) return;
    var missed = {};
    Object.keys(params).forEach(function (k) {
      var val = params[k];
      if (!val) return;
      var names = ALIAS[k] || [k], ok = false;
      for (var i = 0; i < names.length && !ok; i++) ok = fillField(root, names[i], val, onlyIfEmpty);
      if (!ok) missed[k] = val;
    });
    // Some fields (e.g. colors per wool type) may appear only after an earlier field changed: try those once more.
    if (!retry && Object.keys(missed).length) setTimeout(function () { prefill(missed, onlyIfEmpty, true); }, 120);
  }

  function paramsOf(url) { var o = {}; url.searchParams.forEach(function (v, k) { o[k] = v; }); return o; }

  function enquireLink(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-pol-enquire]') : null;
    if (!a || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return null;
    var u;
    try { u = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return null; }
    return u.pathname === window.location.pathname ? { a: a, u: u } : null;
  }

  // 1) Capture phase, only for a form without the API: fill it before any other handler runs.
  window.addEventListener('click', function (e) {
    if (formApi()) return; // the enquiry section's own click handler applies the link (no double handling)
    var l = enquireLink(e);
    if (l) prefill(paramsOf(l.u));
  }, true);

  // 2) Bubble phase: if nobody handled the link, stay on the page (no reload), keep the choice in the URL, scroll.
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var l = enquireLink(e);
    if (!l) return;
    e.preventDefault();
    var cur = new URL(window.location.href);
    l.u.searchParams.forEach(function (v, k) { cur.searchParams.set(k, v); });
    cur.hash = l.u.hash || '#' + ENQUIRY_ID;
    try { window.history.replaceState(window.history.state, '', cur.toString()); } catch (err) {}
    var t = document.getElementById(cur.hash.slice(1)) || formRoot();
    if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  window.ncPol = { prefill: prefill };

  /* ---------- Reveal + lazy video loops ---------- */
  var revealIO = hasIO && !reduce ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  var videoIO = hasIO && !reduce ? new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      var v = e.target;
      if (v.hasAttribute('data-pol-keep')) return;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; play(v); } else if (!v.paused) v.pause();
    });
  }, { threshold: 0.15 }) : null;

  function initReveal(scope) {
    $$('[data-pol-rv],[data-pol-clip]', scope).forEach(function (el) {
      if (!once(el, 'rv')) return;
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
    $$('video.pol-lazy', scope).forEach(function (v) {
      if (!once(v, 'vid')) return;
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.setAttribute('playsinline', ''); v.loop = true;
      if (reduce) return;
      if (videoIO) videoIO.observe(v); else play(v);
    });
  }

  /* ---------- Hero: play the video that fits the screen (CSS hides the other), scroll parallax ---------- */
  function initHero(hero) {
    if (!hero || !once(hero, 'hero')) return;
    var mq = window.matchMedia('(max-width: 699px)');
    var vids = $$('video', hero);
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
    function pick() {
      vids.forEach(function (v) {
        var on = v.classList.contains(mq.matches ? 'pol-hero__v--m' : 'pol-hero__v--d');
        if (on && !reduce) { v.preload = 'auto'; play(v); } else if (!v.paused) v.pause();
      });
    }
    pick();
    if (mq.addEventListener) mq.addEventListener('change', pick); else if (mq.addListener) mq.addListener(pick);
    if (reduce) return;
    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var p = Math.min(1, Math.max(0, window.scrollY / (hero.offsetHeight || 1)));
        hero.style.setProperty('--hp', p.toFixed(3));
      });
    }, { passive: true });
  }

  /* ---------- Mobile quote bar: shows after the hero, hides at the form and at the final call to action ---------- */
  function initSticky(hero) {
    var anchor = document.getElementById(ENQUIRY_ID);
    if (!hero || !anchor || document.querySelector('.pol-sticky')) return;
    var css = document.createElement('style');
    css.textContent = '.pol-sticky{position:fixed;left:0;right:0;bottom:0;z-index:45;display:none;align-items:center;gap:14px;padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:rgba(255,255,255,.96);-webkit-backdrop-filter:blur(12px);backdrop-filter:blur(12px);border-top:1px solid rgba(29,26,23,.12);box-shadow:0 -18px 40px -30px rgba(29,26,23,.35);transform:translateY(110%);transition:transform .45s cubic-bezier(.2,.8,.2,1);font-family:var(--text-font-family);color:#1d1a17}' +
      '@media (max-width:699px){.pol-sticky{display:flex}}.pol-sticky.is-on{transform:none}' +
      '.pol-sticky__txt{flex:1;min-width:0;line-height:1.25}.pol-sticky__txt strong{display:block;font-family:var(--heading-font-family);font-weight:300;font-size:1.05rem;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.pol-sticky__txt span{display:block;font-size:.62rem;letter-spacing:.2em;text-transform:uppercase;color:#6f675d;margin-top:2px}' +
      '.pol-sticky__btn{flex:none;display:inline-flex;align-items:center;gap:10px;background:#1d1a17;color:#fff;text-decoration:none;font-size:.66rem;font-weight:500;letter-spacing:.16em;text-transform:uppercase;padding:15px 18px}' +
      '.pol-sticky__btn svg{display:inline-block}' +
      '@media (prefers-reduced-motion:reduce){.pol-sticky{transition:none}}';
    document.head.appendChild(css);

    var bar = document.createElement('div');
    bar.className = 'pol-sticky';
    bar.setAttribute('aria-hidden', 'true');
    var txt = document.createElement('div'); txt.className = 'pol-sticky__txt';
    var t1 = document.createElement('strong'); t1.textContent = hero.getAttribute('data-sticky-title') || 'Custom furniture';
    var t2 = document.createElement('span'); t2.textContent = hero.getAttribute('data-sticky-sub') || 'Free quote';
    txt.appendChild(t1); txt.appendChild(t2);
    var btn = document.createElement('a');
    btn.className = 'pol-sticky__btn';
    btn.href = hero.getAttribute('data-sticky-link') || '#' + ENQUIRY_ID;
    btn.tabIndex = -1;
    btn.textContent = (hero.getAttribute('data-sticky-label') || 'Request a quote') + ' ';
    btn.insertAdjacentHTML('beforeend', '<svg width="12" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" aria-hidden="true"><path d="M0 5h13M9 1l4 4-4 4"/></svg>');
    bar.appendChild(txt); bar.appendChild(btn);
    document.body.appendChild(bar);

    var formSec = formRoot() || anchor, fin = document.querySelector('.pol-final'), vis = { f: false, e: false };
    function upd() {
      var on = window.scrollY > hero.offsetHeight * 0.7 && !vis.f && !vis.e;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    if (hasIO) {
      new IntersectionObserver(function (en) { vis.f = en[0].isIntersecting; upd(); }, { threshold: 0, rootMargin: '0px 0px -30% 0px' }).observe(formSec);
      if (fin) new IntersectionObserver(function (en) { vis.e = en[0].isIntersecting; upd(); }, { threshold: 0.25 }).observe(fin);
    }
    var st = false;
    window.addEventListener('scroll', function () {
      if (st) return;
      st = true;
      requestAnimationFrame(function () { st = false; upd(); });
    }, { passive: true });
    upd();
  }

  /* ---------- Ideas gallery: round cursor label on desktop ---------- */
  function initGallery(scope) {
    $$('[data-pol-gal]', scope).forEach(function (g) {
      if (!once(g, 'gal')) return;
      if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var c = document.createElement('div');
      c.className = 'pol-cursor';
      c.setAttribute('aria-hidden', 'true');
      c.textContent = g.getAttribute('data-cursor') || 'Request';
      document.body.appendChild(c);
      g.classList.add('has-cursor');
      g.addEventListener('mousemove', function (e) { c.style.setProperty('--cx', e.clientX + 'px'); c.style.setProperty('--cy', e.clientY + 'px'); });
      $$('.pol-tile', g).forEach(function (t) {
        t.addEventListener('mouseenter', function () { c.classList.add('is-on'); });
        t.addEventListener('mouseleave', function () { c.classList.remove('is-on'); });
      });
    });
  }

  /* ---------- Sheepskin section: sticky media follows the card in view (desktop) ---------- */
  function initMaterial(scope) {
    $$('[data-pol-mat]', scope).forEach(function (s) {
      if (!once(s, 'mat')) return;
      var items = $$('.pol-mat__item', s), layers = $$('.pol-mat__frame > div', s), cnt = s.querySelector('[data-pol-mat-no]');
      var cur = 0, near = !hasIO;
      function set(i) {
        cur = i;
        items.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
        layers.forEach(function (x, k) {
          x.classList.toggle('is-on', k === i);
          var v = x.querySelector('video');
          if (v) { if (k === i && near && !reduce && x.offsetParent !== null) play(v); else if (!v.paused) v.pause(); }
        });
        if (cnt) cnt.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + items.length).slice(-2);
      }
      set(0);
      if (!hasIO) return;
      // Videos only run while the section is on screen
      new IntersectionObserver(function (en) { near = en[0].isIntersecting; set(cur); }, { rootMargin: '150px 0px' }).observe(s);
      // Active card = the one crossing the middle of the screen. Re-checked on every enter AND leave, so the
      // stage cannot get stuck on the lower card when the visitor scrolls back up a little.
      function pick() {
        var mid = window.innerHeight / 2, best = cur, bestD = Infinity;
        items.forEach(function (x, k) {
          var r = x.getBoundingClientRect();
          var d = r.top <= mid && r.bottom >= mid ? 0 : Math.min(Math.abs(r.top - mid), Math.abs(r.bottom - mid));
          if (d < bestD) { bestD = d; best = k; }
        });
        if (best !== cur) set(best);
      }
      var mo = new IntersectionObserver(pick, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (x) { mo.observe(x); });
    });
  }

  /* ---------- Film: silent loop, click for sound ---------- */
  function initFilm(scope) {
    $$('[data-pol-film]', scope).forEach(function (f) {
      if (!once(f, 'film')) return;
      var v = f.querySelector('video');
      if (!v) return;
      var btn = f.querySelector('[data-pol-film-play]'), ctl = f.querySelector('[data-pol-film-ctl]'), bar = f.querySelector('[data-pol-film-bar]');
      var lblOn = f.getAttribute('data-on') || 'Watch with sound', lblOff = f.getAttribute('data-off') || 'Sound off';
      v.muted = true;
      function sound(on) {
        v.muted = !on;
        f.classList.toggle('is-sound', on);
        if (ctl) { ctl.querySelector('span').textContent = on ? lblOff : lblOn; ctl.setAttribute('aria-pressed', on ? 'true' : 'false'); }
        if (on) { v.currentTime = 0; v.setAttribute('data-pol-keep', ''); } else v.removeAttribute('data-pol-keep');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); sound(true); });
      if (ctl) ctl.addEventListener('click', function (e) { e.stopPropagation(); sound(v.muted); });
      f.querySelector('.pol-film__frame').addEventListener('click', function () { sound(v.muted); });
      v.addEventListener('timeupdate', function () { if (bar && v.duration) bar.style.transform = 'scaleX(' + v.currentTime / v.duration + ')'; });
    });
  }

  /* ---------- Fallback: prefill the form from the page URL (only empty fields; the form handles its own params first) ---------- */
  function prefillFromUrl() {
    if (formApi()) return; // the enquiry section reads the page URL itself
    var known = {};
    Object.keys(ALIAS).forEach(function (k) { known[k] = 1; });
    $$('a[data-pol-enquire]').forEach(function (a) {
      try { new URL(a.getAttribute('href'), window.location.href).searchParams.forEach(function (v, k) { known[k] = 1; }); } catch (e) {}
    });
    var p = paramsOf(new URL(window.location.href)), use = {};
    Object.keys(p).forEach(function (k) { if (known[k]) use[k] = p[k]; });
    if (Object.keys(use).length) prefill(use, true);
  }

  function init(scope) {
    initReveal(scope);
    initGallery(scope);
    initMaterial(scope);
    initFilm(scope);
    var hero = document.querySelector('[data-pol-hero]');
    initHero(hero);
    initSticky(hero);
  }

  function boot() { init(document); prefillFromUrl(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: sections re-rendered after a settings change
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
